// extracted by mini-css-extract-plugin
module.exports = {"outer":"CenteredContainer_outer__3DnUJ","inner":"CenteredContainer_inner__2z8Dh"};